import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { brokerDebtCertificateCall } from "../api/brokerDebtCertificate";
import { formatNumber } from "../utils/utils";
import { formatDateHourDb } from "../utils/tools";
import { NumberOfPerPage } from "../utils/globalVariable";

const NUMBER_PER_PAGE = NumberOfPerPage?.brokerDebtCertificatePeriod || 20;
const queryKey = "brokerDebtCertificatePeriod";

async function fetchBrokerDebtCertificatePeriod(employeeId, currentPage) {
  try {
    if (!employeeId) return { data: [], totalPages: 0, entries: 0 };

    const res = await brokerDebtCertificateCall.getPeriodList(employeeId, {
      page: currentPage,
      limit: NUMBER_PER_PAGE,
    });

    const items = res?.items || [];
    const pagination = res?.pagination || {};
    const total = pagination?.total || 0;
    const totalPages = Math.ceil(total / NUMBER_PER_PAGE);
    const startEntry = (currentPage - 1) * NUMBER_PER_PAGE + 1;
    const endEntry   = Math.min(currentPage * NUMBER_PER_PAGE, total);

    const data = items.map((item) => ({
      _id:            item._id,
      apartmentCode:  item.apartmentCode || "—",
      period:         item.period != null ? `Đợt ${item.period}` : "—",
      monthYear:      item.monthYear || "—",
      // Round về đồng (VNĐ) — không hiển thị phần thập phân.
      amountHeld:     item.amountHeld != null ? `${formatNumber(Math.round(Number(item.amountHeld)))} VNĐ` : "0 VNĐ",
      // true = PDV đã tính (bulkCalculator), false = nhập thủ công
      source:         item.supersededByPdv ? "Tính toán PDV" : "Import CCMG",
      createdAt:      item.createdAt,
      updatedDate:    item.updatedAt ? formatDateHourDb(item.updatedAt, 1) : "—",
    }));

    return { data, totalPages, entries: total, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching brokerDebtCertificatePeriod:", error);
    return { data: [], totalPages: 0, entries: 0 };
  }
}

export function useBrokerDebtCertificatePeriod(employeeId) {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, employeeId, currentPage],
    queryFn:  () => fetchBrokerDebtCertificatePeriod(employeeId, currentPage),
    enabled:  !!employeeId,
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
  });

  return {
    periodListData: data?.data || [],
    totalPages:     data?.totalPages || 0,
    entries:        data?.entries    || 0,
    startEntry:     data?.startEntry || 0,
    endEntry:       data?.endEntry   || 0,
    currentPage,
    setCurrentPage,
    refetch,
    isLoading,
    isRefetching,
  };
}
